export enum AccreditationStep {
  COMPANY_DATA = 'company_data',
  PERSONAL_DATA = 'personal_data',
  EXPERTS = 'experts',
  HR_DATA = 'hr_data',
  BANKING_ACCESSES = 'banking_accesses',
  EXPERT_PROFILE = 'expert_profile',
  BHP_TEST = 'bhp_test',
  KNF_TEST = 'knf_test',
  STMT_TEST = 'stmt_test',
  ETHIC_TEST = 'ethic_test',
  BANK_STMT_TEST = 'bank_stmt_test',
}
